import { useMutation, useQuery } from '@tanstack/react-query';
import type { JSX } from 'react';
import { PageSection } from '@/components/layout/page.js';
import { Badge } from '@/components/ui/badge.js';
import { Button } from '@/components/ui/button.js';
import { ErrorState } from '@/components/ui/error-state.js';
import { toast } from '@/lib/toast.js';
import { fetchFtpSettings, testFtpConnection } from './api-ftp.js';
import { settingsKeys } from './query-keys.js';

/** Connection details are intentionally read-only; operators update encrypted settings from the CLI. */
export function MarteletConnectionSection(): JSX.Element {
  const query = useQuery({ queryKey: settingsKeys.ftp, queryFn: fetchFtpSettings });
  const test215 = useMutation({ mutationFn: () => testFtpConnection('215'), onSuccess: (result) => result.ok ? toast.success(result.message) : toast.error(result.message), onError: (error: unknown) => toast.fromError(error) });
  const test216 = useMutation({ mutationFn: () => testFtpConnection('216'), onSuccess: (result) => result.ok ? toast.success(result.message) : toast.error(result.message), onError: (error: unknown) => toast.fromError(error) });
  return (
    <PageSection title="Connexion Martelet" description="Connexion FTP gérée par l’exploitation.">
      {query.isPending ? <p className="text-sm text-muted-foreground">Chargement…</p> : query.isError ? (
        <ErrorState message="Impossible de charger la connexion Martelet." onRetry={() => void query.refetch()} />
      ) : <div className="flex flex-col gap-4">
        <div className="flex flex-wrap items-center gap-3 text-sm">
          <Badge tone={query.data.account215.passwordConfigured && query.data.account216.passwordConfigured ? 'green' : 'orange'}>
            {query.data.account215.passwordConfigured && query.data.account216.passwordConfigured ? 'Configurée' : 'À compléter'}
          </Badge>
          <span>{query.data.host}</span>
        </div>
        <div className="flex flex-wrap gap-2">
          <Button type="button" variant="outline" isLoading={test215.isPending} onClick={() => test215.mutate()}>Tester les commandes</Button>
          <Button type="button" variant="outline" isLoading={test216.isPending} onClick={() => test216.mutate()}>Tester les factures</Button>
        </div>
        <details className="text-xs text-muted-foreground"><summary className="cursor-pointer">Détails techniques</summary>
          <p>Port {query.data.port} · Entrée {query.data.dirIn} · Sortie {query.data.dirOut}</p>
        </details>
      </div>}
    </PageSection>
  );
}
